import format from "date-fns/format";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faExclamationTriangle, faCheckCircle } from "@fortawesome/pro-regular-svg-icons";

import { pazienHistory } from "common/components/pazienHistory";
import { Hovercard } from "common/components/hovercard";

const iconMap = {
    error: faExclamationCircle,
    ok: faCheckCircle,
    warn: faExclamationTriangle
};

function StatusIcon({ icon }) {
    return icon && <FontAwesomeIcon icon={icon} size="lg" />;
}

export function DashboardWidget(props) {
    const goToReport = () => {
        pazienHistory.navigateWithParams(props.report_uri, { trigger: true });
    };
    
    const getContent = () => {
        if (props.error_traceback) {
            return (
                <Hovercard position="bottom" className="auto-width" header="Error traceback" body={props.error_traceback}>
                    <div className="text traceback">{props.text}</div>
                </Hovercard>
            );
        }
        return (<div className="text">{props.text}</div>);
    };
    
    return (
        <Widget key={`widget_${props.widget_id}`}>
            <div onClick={goToReport} className={`titleBar ${props.status}`} >
                <div className="title">{props.title}</div>
                <div className="icon"><StatusIcon icon={iconMap[props.status]} /></div>
            </div>
            <div className="statusLabel">STATUS: <span className={props.status}>{props.status}</span></div>
            <div className="content">{getContent()}</div>
            <div className="footer">Modified: {format(new Date(props.modified), "MM/yyyy/dd 'T'HH:mm")}</div>
        </Widget>
    );
}

const Widget = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin: 10px;
    min-width: 300px;
    max-width: 300px;
    width: 300px;
    height: 350px;
    background: white;
    border: 1px solid ${(props) => props.theme.colors["gray-soft"]};
    font-family: ${(props) => props.theme.text.regular};
    
    .titleBar {
        display: flex;
        justify-content: space-between;
        margin: 10px 10px 5px 10px;
        padding: 10px 5px;
        color: white;
        font-size: ${({ theme }) => theme.fontSizeExtraLarge};
        cursor: pointer;
        &.error {
            background-color: ${(props) => props.theme.colors["wcag-magenta"]};
        }
        &.warn {
            background-color: ${(props) => props.theme.colors["orange-mid"]};
        }
        &.ok {
            background-color: ${(props) => props.theme.colors["green-leaf"]};
        }
        .title {
            flex-grow: 1;
        }
        .icon {
            flex-grow: 0;
        }
    }
    .statusLabel {
        margin: 0 10px;
        text-align: right;
        font-size: ${({ theme }) => theme.fontSizeLarge};
        span {
            text-transform: uppercase;
            font-family: ${(props) => props.theme.text.bold};
            &.error {
                color: ${(props) => props.theme.colors["wcag-magenta"]};
            }
            &.warn {
                color: ${(props) => props.theme.colors["orange-mid"]};
            }
            &.ok {
                color: ${(props) => props.theme.colors["green-leaf"]};
            }
        }
    }
    .content {
        display: flex;
        flex-grow: 1;
        margin: 5px 10px;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: ${({ theme }) => theme.fontSizeLarge};
        .text {
            text-align: center;
            max-width: 260px;
            width: 260px;
            max-height: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            &.traceback {
                cursor: pointer;
                background-color: ${(props) => props.theme.colors.brick};
            }
        }
    }
    .footer {
        bottom: 0;
        text-align: center;
        font-size: ${({ theme }) => theme.fontSizeMedium};
    }
`;
